<template>
    <!-- The edit / add model -->
    <!-- modal-xl -->
    <b-modal id="certificateAddModal" size="xl" title="Add Certificate" title-class="font-18" hide-footer @hide="onHide">
        <b-overlay :show="show" rounded="sm">
            <div class="row row-container">
                <div class="left-pane">
                    <b-form-group label-size="sm" label="Supplier Name:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4">
                        <b-form-input
                            v-model="$v.certificate_details.company_name.$model"
                            :state="validateState('company_name')"
                            aria-describedby="input-1-live-feedback"
                            size="sm"
                            type="text"
                            class="b-form-input"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label-size="sm" label="BBBEE Level:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4">
                        <b-form-select
                            v-model="$v.certificate_details.bbbee_level.$model"
                            :state="validateState('bbbee_level')"
                            aria-describedby="input-1-live-feedback"
                            size="sm"
                            :options="bee_level_options"
                            class="b-form-input"
                        ></b-form-select>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Company Size:" label-size="sm" label-cols-sm="4" class="b-form-group align-text-setting">
                        <b-form-select
                            v-model="$v.certificate_details.company_size.$model"
                            :state="validateState('company_size')"
                            aria-describedby="input-1-live-feedback"
                            :options="company_size_options"
                            size="sm"
                        ></b-form-select>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                    </b-form-group>

                    <!-- <b-form-group label-size="sm" label="Economic Interest:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4">
                        <b-input-group append="%" class="" size="sm">
                            <b-form-input
                                size="sm"
                                v-model="certificate_details.black_economic_interest"
                                class="b-form-input"
                                type="number"
                                min="0"
                                max="100"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group> -->

                    <!-- <b-form-group label-size="sm" label="Voting Rights:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4">
                        <b-input-group append="%" class="" size="sm">
                            <b-form-input
                                size="sm"
                                v-model="certificate_details.black_voting_rights"
                                class="b-form-input"
                                type="number"
                                min="0"
                                max="100"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group> -->
                    <b-form-group label="Sector Code:" label-size="sm" label-cols-sm="4" class="b-form-group align-text-setting">
                        <b-form-select
                            v-model="$v.certificate_details.sector_code_id.$model"
                            :state="validateState('sector_code_id')"
                            aria-describedby="input-1-live-feedback"
                            :options="sector_code_options"
                            size="sm"
                        ></b-form-select>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label-size="sm" label="Vat No:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4">
                        <b-form-input
                            disabled
                            v-model="$v.certificate_details.vat_no.$model"
                            :state="validateState('vat_no')"
                            aria-describedby="input-1-live-feedback"
                            size="sm"
                            type="text"
                            class="b-form-input not-allowed-pointer"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> {{ vatNoErrorMessage }} </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label-size="sm" label="Company Reg No:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4">
                        <b-form-input
                            disabled
                            v-model="$v.certificate_details.company_reg.$model"
                            :state="validateState('company_reg')"
                            aria-describedby="input-1-live-feedback"
                            size="sm"
                            type="text"
                            class="b-form-input not-allowed-pointer"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> {{ regNoErrorMessage }} </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label-size="sm" label="Certificate No:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4">
                        <b-form-input
                            v-model="certificate_details.certificate_no"                            
                            aria-describedby="input-1-live-feedback"
                            size="sm"
                            type="text"
                            class="b-form-input"
                        ></b-form-input>                        
                    </b-form-group>

                    <b-form-group label="Issue Date:" label-cols-sm="4" label-size="sm" class="b-form-group align-text-setting">
                        <!-- <b-form-datepicker v-model="value1" class="mb-2"></b-form-datepicker> -->
                        <b-form-input
                            v-model="$v.certificate_details.issue_date.$model"
                            :state="validateState('issue_date')"
                            aria-describedby="input-1-live-feedback"
                            id="date"
                            type="date"
                            size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Expiry Date:" label-cols-sm="4" label-size="sm" class="b-form-group align-text-setting">
                        <b-form-input
                            v-model="$v.certificate_details.expiry_date.$model"
                            :state="validateState('expiry_date')"
                            aria-describedby="input-1-live-feedback"
                            id="date"
                            type="date"
                            size="sm"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label-size="sm" label="Document Type:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4">
                        <b-form-select
                            v-model="$v.certificate_details.document_type.$model"
                            @change="set_verification_agency"
                            :state="validateState('document_type')"
                            aria-describedby="input-1-live-feedback"
                            size="sm"
                            :options="doc_type_options"
                            class="b-form-input"
                        ></b-form-select>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                        v-if="certificate_details.document_type == 'Certificate'"
                        label-size="sm"
                        label="Agency:"
                        label-for=""
                        class="b-form-group align-text-setting"
                        label-cols-sm="4"
                    >
                        <b-form-select
                            v-model="$v.certificate_details.verification_agency_id.$model"
                            :state="validateState('verification_agency_id')"
                            @change="set_verification_agency"
                            aria-describedby="input-1-live-feedback"
                            size="sm"
                            :options="agency_options"
                            class="b-form-input"
                        ></b-form-select>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2"> Required </b-form-invalid-feedback>
                    </b-form-group>

                    <!-- <input type="file" @change="onFileSelected" /> -->
                    <!-- <button @click="onUpload">upload the file</button> -->
                    <b-alert class="b-form-group text-center" variant="danger" :show="proof_error" dismissible>
                        You must provide a certificate
                    </b-alert>

                    <div class="group-of-actions d-flex justify-content-center">
                        <div class="input-file m-1 mt-2">
                            <input @change="onFileSelected" class="btn btn-primary" ref="file" type="file" style="display: none;" />
                            <div class="btn btn-primary" @click="selectFile()">Upload</div>
                        </div>
                        <div>
                            <b-button :disabled="!selectedFile" @click="newWindow" variant="primary" class="btn btn-primary m-1 mt-2"
                                ><i class="mdi mdi-dock-window mr-1"></i> View</b-button
                            >
                        </div>
                        <!-- <b-button
                            v-if="certificate_details.shared == 0"
                            @click="handleModal('certificateSharingModal')"
                            variant="primary"
                            type="button"
                            class="btn btn-primary m-1 mt-2"
                        >
                            Share
                        </b-button> -->
                    </div>
                </div>

                <!-- <b-overlay :show="!show" rounded="sm" class="right-pane"> -->
                <div class="right-pane" v-if="selectedFile">
                    <embed :src="selectedFilePreview" class="w-100 h-100" />
                </div>
                <!-- show if no certifacate in pane -->
                <div v-else class="right-pane d-flex justify-content-center">
                    <div class="text-center font-weight-bold ">Upload a certificate to preview it</div>
                </div>
                <!-- </b-overlay> -->
            </div>

            <div class="modal-footer mt-3">
                <b-button @click="saveCertificate" variant="primary" type="button" class="btn btn-primary">
                    Save
                </b-button>
                <b-button variant="primary" type="button" class="btn btn-primary" @click="closeModal">
                    Close
                </b-button>
            </div>
        </b-overlay>
    </b-modal>
</template>

<script>
//eslint-disable-next-line
import Swal from "sweetalert2";
//eslint-disable-next-line
import { required, minLength, maxLength, numeric, date } from "vuelidate/lib/validators";
import { adminComputed, suppliersComputed, suppliersMethods } from "../../state/helpers";

export default {
    data: () => ({
        proof_error: false,
        formSubmit: false,
        show: false,
        selected_agency: null,
        file_upload_type: null,
        selectedFile: "",
        selectedFilePreview: "https://www.africau.edu/images/default/sample.pdf#page=1&zoom=75&toolbar=0",
        certificate_details: {
            // certificate_id: "",
            company_name: "",
            sector_code_id: "",
            verification_agency_id: null,
            vat_no: "",
            company_reg: "",
            certificate_no: "",
            expiry_date: "",
            issue_date: "",
            bbbee_level: null,
            company_size: null,
            document_type: null,
            certificate: "",
            capture_user: "",
            capture_user_id: "",
        },

        doc_type_options: [
            { value: null, text: "Please select an option", disabled: true },
            { value: "Certificate", text: "Certificate" },
            { value: "Affidavit", text: "Affidavit" },
        ],
        company_size_options: [
            { value: null, text: "Please select an option", disabled: true },
            { value: "Generic", text: "Generic" },
            { value: "EME", text: "EME" },
            { value: "QSE", text: "QSE" },
        ],
        bee_level_options: [
            { value: null, text: "Please select an option", disabled: true },
            { value: "non compliant", text: "-- non compliant --" },
            { value: "1", text: "1" },
            { value: "2", text: "2" },
            { value: "3", text: "3" },
            { value: "4", text: "4" },
            { value: "5", text: "5" },
            { value: "6", text: "6" },
            { value: "7", text: "7" },
        ],
        sector_code_options: [
            { value: null, text: "Please select an option", disabled: true },
            { value: "1", text: "Accounting" },
            { value: "2", text: "Agri" },
            { value: "3", text: "Construction" },
            { value: "4", text: "Defence" },
            { value: "5", text: "DTIC" },
            { value: "6", text: "Financial" },
            { value: "7", text: "Forestry" },
            { value: "8", text: "ICT" },
            { value: "9", text: "Legal" },
            { value: "10", text: "MAC" },
            { value: "11", text: "Property" },
            { value: "12", text: "Tourism" },
            { value: "13", text: "Transport" },
        ],
    }),
    validations: {
        certificate_details: {
            company_name: {
                required,
            },
            bbbee_level: {
                required,
            },
            company_size: {
                required,
            },
            sector_code_id: {
                required,
            },
            vat_no: {
                conditionalRequired(value) {
                    const isVatNoFilled = !!value;
                    const isCompanyRegFilled = !!this.certificate_details.company_reg;
                    return isVatNoFilled || isCompanyRegFilled;
                },
                minLength: minLength(10),
                maxLength: maxLength(10),
                numeric,
            },
            company_reg: {
                conditionalRequired(value) {
                    const isVatNoFilled = !!this.certificate_details.vat_no;
                    const isCompanyRegFilled = !!value;
                    return isVatNoFilled || isCompanyRegFilled;
                },
                minLength: minLength(3),
            },
            issue_date: {
                required,
            },
            expiry_date: {
                required,
            },
            document_type: {
                required,
            },
            verification_agency_id: { required },
        },
    },
    computed: {
        ...adminComputed,
        ...suppliersComputed,

        agency_options() {
            let agency_options = [{ value: null, text: "Please select an option", disabled: true }];

            this.agencies.map((agency) => {
                if (agency.name != "Affidavit") {
                    agency_options.push({ value: agency.id, text: agency.name });
                }
            });

            return agency_options;
        },

        vatNoErrorMessage() {
            if (!this.$v.certificate_details.vat_no.$dirty) return "";
            if (!this.$v.certificate_details.vat_no.conditionalRequired) {
                return "Either a VAT No or Reg No must be provided.";
            }
            if (this.$v.certificate_details.vat_no.$error) {
                if (this.$v.certificate_details.vat_no.maxLength) {
                    return "VAT No must be 10 digits long.";
                }
                if (this.$v.certificate_details.vat_no.$params.numeric) {
                    return "Can only be numbers.";
                }
                return "A Vat No can only be 10 digits long.";
            }
            return "";
        },
        regNoErrorMessage() {
            if (!this.$v.certificate_details.company_reg.$dirty) return "";
            if (!this.$v.certificate_details.company_reg.conditionalRequired) {
                return "Either a Reg No or Vat no must be provided.";
            }
            if (this.$v.certificate_details.company_reg.$error) {
                if (this.$v.certificate_details.company_reg.$params.minLength) {
                    return "Reg No must be atleast 3 characters long";
                }
                return "Required";
            }
            return "";
        },
    },
    methods: {
        ...suppliersMethods,
        set_verification_agency() {
            //eslint-disable-next-line
            console.log("Fiiiiirst", this.certificate_details.document_type, "verification agency", this.certificate_details.verification_agency_id);
            if (this.certificate_details.document_type == "Affidavit") {
                //eslint-disable-next-line
                console.log("set to affidavit");
                this.certificate_details.verification_agency_id = "1";

                //eslint-disable-next-line
                console.log(
                    "!!!!!!!!what isthe vmodel",
                    this.certificate_details.document_type,
                    "verification agency",
                    this.certificate_details.verification_agency_id
                );
            }

            if (this.certificate_details.document_type == "Certificate" && this.certificate_details.verification_agency_id == "1") {
                this.certificate_details.verification_agency_id = null;

                //eslint-disable-next-line
                console.log(
                    "!!!!!!!!what isthe vmodel",
                    this.certificate_details.document_type,
                    "verification agency",
                    this.certificate_details.verification_agency_id
                );
            }

            // if (this.certificate_details.document_type == "Certfiicate") {
            //     //eslint-disable-next-line
            //     console.log(
            //         "!!!!!!!!what isthe vmodel",
            //         this.certificate_details.document_type,
            //         "verification agency",
            //         this.certificate_details.verification_agency_id
            //     );
            // }
        },
        onHide(evt) {
            if (evt.trigger === "backdrop") {
                // evt.preventDefault();
                this.localSetCertificateDetails();
                //eslint-disable-next-line
                console.log("the backdrop was clicked1", evt);
                // this.handleBackdrop();
                this.closeModal();
            }
        },
        // handleBackdrop() {
        //     //eslint-disable-next-line
        //     console.log("Backdrop clicked2");
        //     this.closeModal();
        // },
        selectFile() {
            let fileInputElement = this.$refs.file;
            fileInputElement.click();

            //eslint-disable-next-line
            // console.log("target", e, fileInputElement);
            // ...
        },
        validateState(name) {
            if (this.formSubmit) {
                const { $dirty, $error } = this.$v.certificate_details[name];
                return $dirty ? !$error : null;
            }
        },
        closeModal() {
            this.formSubmit = false;
            this.$bvModal.hide("certificateAddModal");
            this.localSetCertificateDetails(); // resets component state
        },
        onFileSelected(event) {
            //eslint-disable-next-line

            // this.selectedFile = event.target.files[0];
            this.selectedFile = URL.createObjectURL(event.target.files[0]);
            this.selectedFilePreview = URL.createObjectURL(event.target.files[0]) + "#page=1&zoom=75&toolbar=0";
            //eslint-disable-next-line
            console.log(this.selectedFile, event.target.files[0]);

            // !
            // this.certificate_details.certificate = this.$refs.file.files[0];
            this.certificate_details.certificate = event.target.files[0];

            this.proof_error = false;
        },
        newWindow() {
            window.open(this.selectedFilePreview, "_blank");
        },
        localSetCertificateDetails() {
            //eslint-disable-next-line
            console.log("the local state of add cert", this.searchFor_certificates_details);
            //pulled from details
            // this.certificate_details.company_name = this.selected_supplier_details.company_name;
            // this.certificate_details.company_name = "";
            //pulled from search
            this.certificate_details.company_name = this.searchFor_certificates_details.supplier_name;
            this.certificate_details.sector_code_id = null;
            this.certificate_details.verification_agency_id = null;

            this.certificate_details.vat_no = this.searchFor_certificates_details.vat_no;
            this.certificate_details.company_reg = this.searchFor_certificates_details.company_reg;

            this.searchFor_certificates_details.expiry_date.length > 0
                ? (this.certificate_details.expiry_date = this.searchFor_certificates_details.expiry_date.substring(0, 10))
                : "";

            this.searchFor_certificates_details.issue_date.length > 0
                ? (this.certificate_details.issue_date = this.searchFor_certificates_details.issue_date.substring(0, 10))
                : "";
            this.certificate_details.bbbee_level = null;
            this.certificate_details.company_size = null;

            this.certificate_details.document_type = this.searchFor_certificates_details.document_type;
            if (this.certificate_details.document_type == "Affidavit") {
                //set the agency id here so that it is poulated in the back ground
                this.set_verification_agency();
            }

            this.selectedFile = "";
            this.selectedFilePreview = "";

            // ! hardcoded
            // this.certificate_details.capture_user = "Guy";
            // this.certificate_details.capture_user_id = "241";
            //eslint-disable-next-line
            console.log("user details", this.username, this.user_id);
            this.certificate_details.capture_user = this.username;
            this.certificate_details.capture_user_id = this.user_id;

            //eslint-disable-next-line
            // console.log("local sttings details", this.username, this.user_id);
        },
        handleModal(modelName) {
            this.$emit("handleModal", modelName);
            this.closeModal();
        },
        saveCertificate() {
            this.certificate_details.client_supplier_id = this.selected_supplier_details.id;

            if (this.certificate_details.certificate.length < 2) {
                this.proof_error = true;
            }

            this.formSubmit = true;

            this.$v.certificate_details.$touch();
            if (this.$v.certificate_details.$anyError) {
                return;
            }

            if (this.proof_error == true) return;

            Swal.fire({
                title: ` Are you sure you would like to add this certificate? `,
                text: ``,
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.value) {
                    this.saveClientSupplierCertificateDetails(this.certificate_details).then(() => {
                        this.formSubmit = false;
                        Swal.fire({ title: ``, text: "Certificate was added", icon: "success" });
                        // this.$emit("handleModal", "certificateEditModal");
                        // this.$emit("handleModal", "certificateListModal");
                        this.closeModal();
                    });
                }
            });
        },
    },

    //  ! TDODO:
    // watch: {
    //     //modal is not destroyed so the mount doesnt run again
    //     searchFor_certificates_details() {
    //         this.localSetCertificateDetails();
    //     },
    // },
    mounted() {
        this.certificate_details.company_name = this.selected_supplier_details.supplier_name;

        this.setAgencies();

        this.localSetCertificateDetails();
    },
};
</script>

<style lang="scss" scoped>
//   the default style attached to modal footer  border-top: 1px solid #eff2f7;
.align-text-setting {
    text-align: right;
}
.height {
    min-height: 500px;
}

// this makes the left and right pane in the flex
.row-container {
    display: flex;
    padding: 10px;
}

.left-pane {
    width: 40%;

    .b-form-group {
        margin-right: 30px;
    }
    .b-form-input {
        max-width: 100%;
    }
}
.group-of-actions {
    border-top: 1px solid #eff2f7 !important;
    margin-top: 25px;
    padding-top: 15px;
    margin-right: 25px;
}
.button-width {
    width: 200px;
}
.right-pane {
    // padding: 4px;
    width: 59%;
    display: flex;
    flex-direction: column;
    border: 1px solid black;
}

// the purpose of this media query is simply to make the contents of modal display flex-column
// and then for the panes to have a width off 100% instead of 50%
@media only screen and (max-width: 990px) {
    .align-text-setting {
        text-align: left;
    }
    .row-container {
        flex-direction: column;
    }

    .left-pane {
        width: 100%;
    }

    .right-pane {
        width: 100%;
        margin-top: 25px;
        height: 350px;
    }
}
.swal2-text {
    font-weight: 200;
}

.not-allowed-pointer {
    cursor: not-allowed;
    user-select: none;
}
</style>
